export const squareTestCardNonceWith3DS =
  'cnon:card-nonce-requires-verification';
